import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {RoutesMetadataSettingsModel, RoutesViewSettingsRoutesModel} from "../../../models/routes-view-settings.model";
import {RouteModel} from "../../../models/route.model";
import {TranslateService} from "@ngx-translate/core";
import {TaskPurposeType} from "../../../../commons/types/task-purpose.type";
import {TaskType} from "../../../../tasks/types/task.type";
import {AccountReferenceModel} from "../../../../account/models/account-reference.model";
import {PanelService} from "../../../../commons/angular/services/panel.service";
import {
  TaskRelationsPopupComponent,
  TaskRelationsPopupData
} from "../../../../commons/angular/components/task-relations-popup/task-relations-popup.component";
import {TasksHttpService} from "../../../../tasks/angular/services/tasks-http.service";
import {dedupeRelationsByService} from "../../../../tasks/utils/task-relations.util";
import {TaskRelationModel} from "../../../../tasks/models/task-relation.model";

require('./routes-panel-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-routes-panel-list-item',
  templateUrl: './routes-panel-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoutesPanelListItemComponent implements OnInit, OnChanges {

  @Input() route: RouteModel;
  @Input() settings: RoutesViewSettingsRoutesModel;
  @Input() isSelected: boolean;
  @Input() excludeMode: boolean;
  @Input() isVisible: boolean;
  @Input() isDisabled: boolean;
  @Input() canSelect?: boolean;
  @Input() canClose?: boolean;
  @Input() canShow?: boolean;
  @Input() canLock?: boolean;
  @Input() canDrilldown?: boolean;
  @Output() onToggle = new EventEmitter<boolean>();
  @Output() onToggleVisible = new EventEmitter<{route: RouteModel, isVisible: boolean}>();
  @Output() onLockRouteChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onSelect = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  @Output() onChangeRouteResource = new EventEmitter<{route: any, event: any}>();
  @Output() onDrillDown = new EventEmitter<{ routeId: string, event: any }>();

  public capacity: {
    type: string;
    value: string;
    maxValue: string;
    icon: string;
    percentage: number;
  }
  public routeColor: string;
  public dateRange: { notBefore: string, notAfter: string }
  public isHover: boolean;
  public isShowCopyBtn: boolean = false;
  public pickingTime: any;
  public enabledMetadata: RoutesMetadataSettingsModel[];
  public proNumbers: string[] = [];
  public relations: TaskRelationModel[] = [];
  public weightSeverity: string = '';
  public weightUnit: string = this.splitService.getShortWeightUnit();
  public volumeSeverity: string = '';
  public volumeCapacity: number = 0;
  public volumeUnit: string = this.splitService.getVolumeUnit();
  public palletsSeverity: string = '';
  public severityThresholds: { low: number; mid: number; } = { low: 80, mid: 99 };
  public stopsCount: {pickup: number, dropoff: number, operation: number, destination: number};
  public accountReferences: any[];

  constructor(
    @Inject('$timeout') private $timeout,
    @Inject('splitService') private splitService,
    @Inject(PanelService) private panelService: PanelService,
    @Inject(TasksHttpService) private tasksHttpService: TasksHttpService
  ) { }

  ngOnInit() {
    // this.setRouteColor();
    // this.setDateRange();
    this.setEnabledMetadata();
    this.setRoutePickingTime();
    this.setStopsCountByPurpose();
    this._setAccounts();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.settings && !changes.settings.isFirstChange()) || (changes.route && !changes.route.isFirstChange())) {
      // this.setRouteColor();
      // this.setDateRange();
      this.setEnabledMetadata();
      this.setRoutePickingTime();
      this.setStopsCountByPurpose();
    }

    this.proNumbers = Array.from(this.route.routeTaskList.reduce((acc, task) => {
      if (task.serviceInfo?.proNumber) {
        acc.add(task.serviceInfo.proNumber);
      }
      return acc;
    }, new Set<string>()));

    this.relations = dedupeRelationsByService(
      _.flatMap(this.route.routeTaskList || [], task => task.routeTaskRelations || []),
      TaskPurposeType.Dropoff
    );

    const { totals, maxLoad } = this.route;
    const dimensions = maxLoad?.dimensions;

    this.volumeCapacity = dimensions?.cube ?? ((dimensions?.length ?? 0) * (dimensions?.width ?? 0) * (dimensions?.height ?? 0));
    this.weightSeverity  = this._getSeverity(totals.totalLoad, maxLoad?.weight ?? 0);
    this.volumeSeverity  = this._getSeverity(totals.totalVolume, this.volumeCapacity);
    this.palletsSeverity = this._getSeverity(totals.totalPallets, maxLoad?.numberOfPallets ?? 0);

    this._setAccounts();
  }

  onHover(isHover) {
    this.isHover = isHover;
    this.$timeout(0).then(() => {
    });
  }

  onClick($event) {
    this.onSelect.emit($event);
    this.$timeout(0).then(() => {
    });
  }

  onRelationsClick(event: MouseEvent) {
    const taskIds = _.map(_.filter(this.route.routeTaskList, task => !_.isEmpty(task.routeTaskRelations)), 'id');
    this.panelService.open<TaskRelationsPopupComponent>(TaskRelationsPopupComponent, event, {
      relations: this.relations,
      tasks$: this.tasksHttpService.getTasks(taskIds)
    } as TaskRelationsPopupData);
  }

  onToggleLocked() {
    this.onLockRouteChange.emit({id: this.route.id, locked: !this.route.isBlockedByUser});
  }

  onDrillDownClick($event) {
    $event.stopPropagation();
    this.onDrillDown.emit({routeId: this.route.id, event: $event});
  }

  onDrillDownDblClick($event) {
    $event.stopPropagation();
    this.onDrillDown.emit({routeId: this.route.id, event: $event});
  }

  getTotalIncomeClass(totalIncome?) {
    // const minimumRouteIncome = this.route.resource.routeIncomePreferences?.minimumRouteIncome || this.draft?.settings?.incomeSettings?.minRouteIncome;
    // const maximumRouteIncome = this.route.resource.routeIncomePreferences?.maximumRouteIncome || this.draft?.settings?.incomeSettings?.maxRouteIncome;
    // return (!!minimumRouteIncome && (totalIncome < minimumRouteIncome)) ? 'low' :
    //   ((!!maximumRouteIncome && (totalIncome > maximumRouteIncome)) ? 'high' : '');
  }

  setEnabledMetadata() {
    this.enabledMetadata = this.settings.metadata?.filter(metadata => metadata.enabled);
  }

  private _getSeverity(value: number, capacity?: number): string {
    if (!capacity) {
      return '';
    }
    const ratio = (value / capacity) * 100;
    return (ratio < this.severityThresholds.low) ? 'low' : ((ratio >= this.severityThresholds.low && ratio < this.severityThresholds.mid) ? 'mid' : 'high');
  }

  private setRoutePickingTime() {
    this.pickingTime = {
      time: _.get(this.route, 'routeTaskList[0].routeAnalysis.eta', this.route.notBefore) - ((this.route.pickingTimeOffsetInMinutes || 0) * 60000)
    }
  }

  private setStopsCountByPurpose() {
    let pickups = 0;
    let dropoffs = 0;
    let operations = 0;

    for (const task of this.route.routeTaskList) {
      const purpose = task.taskSpec?.purpose;

      if (purpose === TaskPurposeType.Pickup) {
        pickups++
      }

      if (purpose === TaskPurposeType.Dropoff) {
        dropoffs++
      }

      if (purpose === TaskPurposeType.Operation) {
        operations++
      }
    }

    this.stopsCount = {
      pickup: pickups,
      dropoff: dropoffs,
      operation: operations,
      destination: dropoffs + operations
    };
  }

  private _getPalletsFromPackageList(packageList: any[]): number {
    let totalPallets = 0;
    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          totalPallets += pkg.items.reduce((acc, item) => {
            if (item.pallets) {
              acc += (item.pallets || 0);
            }
            return acc;
          }, 0);
        }
      });
    }
    return Number.isInteger(totalPallets) ? totalPallets : Number(totalPallets.toFixed(2));
  }

  private _setAccounts() {
    if (!this.route?.accountReferences) {
      this.accountReferences = [];
      return;
    }

    // Check if we have any Dropoff tasks on this route
    let hasDropoffs = false;
    if (this.route.routeTaskList) {
      hasDropoffs = this.route.routeTaskList.some((t: any) => t.taskSpec?.purpose === TaskPurposeType.Dropoff);
    }

    // Filter tasks to only count the side (Dropoff if present, otherwise non-Dropoff)
    const filteredTasks = this.route.routeTaskList
      ? this.route.routeTaskList.filter((t: any) => {
          return hasDropoffs ? t.taskSpec?.purpose === TaskPurposeType.Dropoff : t.taskSpec?.purpose !== TaskPurposeType.Dropoff;
        })
      : [];

    this.accountReferences = this.route.accountReferences.map(accRef => {
      const clonedAccRef: any = { ...accRef };
      let palletsSum = 0;

      filteredTasks.forEach((t: any) => {
        if (t.taskType === TaskType.BundledStopover && t.bundledRouteTaskList) {
          t.bundledRouteTaskList.forEach((ct: any) => {
            if (ct.accountReference?.id === clonedAccRef.id) {
              palletsSum += this._getPalletsFromPackageList(ct.packageList);
            }
          });
        } else {
          if (t.accountReference?.id === clonedAccRef.id) {
            palletsSum += this._getPalletsFromPackageList(t.packageList);
          }
        }
      });

      clonedAccRef.pallets = Number.isInteger(palletsSum) ? palletsSum : Number(palletsSum.toFixed(2));
      return clonedAccRef;
    });

    this._sortAccountsByTaskOrder(filteredTasks);
  }

  private _sortAccountsByTaskOrder(tasks) {
    const firstIndexById = new Map<string, number>();

    const registerAccountId = (accountId: string, index: number) => {
      if (accountId && !firstIndexById.has(accountId)) {
        firstIndexById.set(accountId, index);
      }
    };

    (tasks || []).forEach((t: any, index: number) => {
      if (t.taskType === TaskType.BundledStopover && t.bundledRouteTaskList) {
        t.bundledRouteTaskList.forEach((ct: any) => registerAccountId(ct.accountReference?.id, index));
      } else {
        registerAccountId(t.accountReference?.id, index);
      }
    });

    this.accountReferences.sort((a, b) => {
      const aIndex = firstIndexById.has(a.id) ? firstIndexById.get(a.id) : Infinity;
      const bIndex = firstIndexById.has(b.id) ? firstIndexById.get(b.id) : Infinity;
      return aIndex - bIndex;
    });
  }

}
